const verified = {
  verifiying: 'Verifying',
  verifiying_account: 'We are verifying your account!',
  wait: 'Please wait while we are verifying your account, you will be redirected automatically when it\'s done.',
};

export default verified;
